<template>
    <v-container class="fill-height" style="display: block; position: relative;" v-if="$props.show">

        <div id="handle" @mousedown="onMouseDown">
            <v-icon id="handle-icon" x-small>mdi-arrow-left-right-bold</v-icon>
        </div>
        
        <v-container class="icon-tray" style="display: block;">
            <v-btn light color="#c42111" width="100%" class="white--text" small tile :disabled="$props.selectedRows.length != 1" @click="$emit('details')">Details</v-btn>
            <v-btn light color="#c42111" width="100%" class="mt-1 white--text" small tile :disabled="!$props.selectedRows.length || !$props.current" @click="$emit('close')">Close Issue</v-btn>
            <v-btn light color="#c42111" width="100%" class="mt-1 white--text" small tile :disabled="$props.selectedRows.length != 1 || !$props.current" @click="$emit('remark')">Add Remark</v-btn>
            <v-btn light color="#c42111" width="100%" class="mt-1 white--text" small tile :disabled="$props.selectedRows.length != 1 || !$props.current" @click="$emit('schedule')">Schedule</v-btn>
        </v-container>
        
        <div class="drawer-content-container description" v-if="$props.show">
            <span class="title">Description</span>
            <textarea :value="$props.selectedRows.length == 1 && $props.selectedRows[0].issue_description != '' ? $props.selectedRows[0].issue_description : ' '" readonly></textarea>
        </div>

        <div class="drawer-content-container remarks" v-if="$props.show">
            <span class="title">
                Remarks
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon x-small style="margin-top: -2px;" v-bind="attrs" v-on="on">settings</v-icon>
                    </template>
                    <v-list>
                        <v-list-item><v-btn @click="remarksFormat = 'raw'" icon><v-icon :color="remarksFormat == 'raw' ? '#c42111' : '#ffffff'">mdi-format-align-justify</v-icon></v-btn></v-list-item>
                        <v-list-item><v-btn @click="remarksFormat = 'split'" icon><v-icon :color="remarksFormat == 'split' ? '#c42111' : '#ffffff'">mdi-card-text</v-icon></v-btn></v-list-item>
                    </v-list>
                </v-menu>
            </span>

            <textarea :value="formattedIssueRemarks" readonly v-if="remarksFormat == 'raw'" />
            <div class="entry-container" v-if="remarksFormat == 'split'">
                <span class="entry" :class="{odd: (idx+1) % 2}" v-for="remark, idx in $props.selectedRows[0].issue_remarks" :key="remark.journal_id">
                    <span style="font-weight: 500;">{{ `[${remark.username} at ${remark.issue_action_timestamp}] ` }}</span>
                    <span>{{ `${remark.issue_action_details}` }}</span>
                </span>
            </div>
        </div>

        <div class="drawer-content-container history" v-if="$props.show">
            <span class="title">
                History
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon x-small style="margin-top: -2px;" v-bind="attrs" v-on="on">settings</v-icon>
                    </template>
                    <v-list>
                        <v-list-item><v-btn @click="historyFormat = 'raw'" icon><v-icon :color="historyFormat == 'raw' ? '#c42111' : '#ffffff'">mdi-format-align-justify</v-icon></v-btn></v-list-item>
                        <v-list-item><v-btn @click="historyFormat = 'split'" icon><v-icon :color="historyFormat == 'split' ? '#c42111' : '#ffffff'">mdi-card-text</v-icon></v-btn></v-list-item>
                    </v-list>
                </v-menu>
            </span>

            <textarea :value="formattedIssueHistory" readonly v-if="historyFormat == 'raw'" />
            <div class="entry-container" v-if="historyFormat == 'split'">
                <span class="entry" :class="{odd: (idx+1) % 2}" v-for="history, idx in $props.selectedRows[0].issue_history" :key="history.journal_id">
                    <span style="font-weight: 500;">{{ `[${history.username} at ${history.issue_action_timestamp}] ` }}</span>
                    <span>{{ `${history.issue_action_details}` }}</span>
                </span>
            </div>
        </div>

    </v-container>
</template>

<script>
export default {
    name: 'ActionDrawer',
    props: ['selectedRows', 'show', 'current'],
    components: {

    },
    data: () => ({
        remarksFormat: 'raw',
        historyFormat: 'raw'
    }),

    computed: {
        formattedIssueRemarks() {
            if(this.$props.selectedRows.length === 1) {
                let issue = this.$props.selectedRows[0];
                if(issue.issue_remarks && Array.isArray(issue.issue_remarks) && issue.issue_remarks.length) {
                    if(typeof issue.issue_remarks[0] === 'string') {
                        return issue.issue_remarks.join('\n');
                    }
                    return issue.issue_remarks.map(x => `[${x.username} at ${x.issue_action_timestamp}] ${x.issue_action_details}`).join('\n');
                }
            }
            return "";
        },

        formattedIssueHistory() {
            if(this.$props.selectedRows.length === 1) {
                let issue = this.$props.selectedRows[0];
                if(issue.issue_history && Array.isArray(issue.issue_history) && issue.issue_history.length) {
                    if(typeof issue.issue_history[0] === 'string') {
                        return issue.issue_history.join('\n');
                    }
                    return issue.issue_history.map(x => `[${x.username} at ${x.issue_action_timestamp}] ${x.issue_action_details}`).join('\n');
                }
            }
            return "";
        }
    },

    methods: {
        onMouseDown(e) {
            document.addEventListener('mousemove', this.onMouseMove);
            document.addEventListener('mouseup', this.onMouseUp);
            document.getElementById('handle').style.backgroundColor = '#000000';
            document.getElementById('handle-icon').style.color = '#ffffff';
        },
        onMouseMove(e) {
            window.requestAnimationFrame(() => {
                let issuesDrawer = document.getElementById('issues-drawer');
                let agGridIssuesContainer = document.getElementById('ag-grid-issues-container');
                const containerRect = this.$el.getBoundingClientRect();
                const newWidth = containerRect.right - e.clientX;
                if(newWidth < 256) {
                    return;
                }
                issuesDrawer.style.width = `${newWidth}px`;
                agGridIssuesContainer.style.width = `calc(100% - ${newWidth}px)`;
            });
        },
        onMouseUp() {
            document.removeEventListener('mousemove', this.onMouseMove);
            document.removeEventListener('mouseup', this.onMouseUp);
            document.getElementById('handle').style.backgroundColor = '#ffffff';
            document.getElementById('handle-icon').style.color = '#000000';
        }
    },

    mounted() {

    }

  
};
</script>

<style scoped>

    #handle {
        height: 60px;
        width: 10px;
        display: inline-block;
        background-color: #ffffff;
        cursor: pointer;
        position: absolute;
        top: calc(50% - (60px / 2));
        left: -10px;
        z-index: 4;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        border-left: 1px solid rgb(194, 194, 194);
        border-top: 1px solid rgb(194, 194, 194);
        border-bottom: 1px solid rgb(194, 194, 194);
        color: #000000;
        transition: 0.3s ease-in-out;
    }
    #handle i {
        font-size: 18px;
        margin-top: 22px;
        margin-left: 3px;
    }
    #handle:hover {
        width: 15px;
        left: -15px;
        transition: 0.3s ease-in-out;
    }


    #issues-drawer {
        width: 0px;
        height: 0px;
        background-color: #ffffff;
        display: inline-block;
        transition: width 0.1s;
        float: left;
    }
    #issues-drawer.active {
        width: 256px;
        height: calc(100vh - 145px);
        transition: width 0.25s;
    }

    .icon-tray {
        position: relative;
        border: #C2C2C2  solid 1px;
        border-radius: 4px;
        margin-bottom: 25px;
        overflow: auto;
    }




    .drawer-content-container {
        width: 100%;
        border: #C2C2C2 solid 1px;
        border-radius: 5px;
        padding: 8px;
        position: relative;
        margin-bottom: 15px;
    }

    .drawer-content-container textarea {
        width: 100%;
        color: #212121;
        height: calc(100% - 10px);
        outline: none;
        resize: none;
        font-size: 9pt;
        position: relative;
        margin-top: 10px;
    }

    .drawer-content-container .title {
        color: #757575;
        font-size: 10pt !important;
        display: block;
        position: absolute;
        top: -15px;
        background-color: #ffffff;
        z-index: 1;
        padding-left: 3px;
        padding-right: 3px;
    }




    .drawer-content-container .entry-container {
        position: relative;
        overflow: auto;
        display: block;
        width: 100%;
        height: 100%;
        z-index: 2;
    }
    .drawer-content-container .entry {
        font-size: 14px;
        position: relative;
        display: block;
        background-color: #e6f7ff;
        color: #000000;
    }
    .drawer-content-container .entry.odd {
        background-color: #fffde7;
    }
    .drawer-content-container .entry:hover {
        background-color: rgb(210, 252, 210);
    }

    .drawer-content-container .entry span {
        white-space: pre-wrap;
    }







    .drawer-content-container.description {
        height: calc(((100% - 220px) / 10) * 2);
    }
    .drawer-content-container.remarks {
        height: calc(((100% - 220px) / 10) * 3);
    }
    .drawer-content-container.history {
        height: calc(((100% - 220px) / 10) * 5);
    }

</style>
